import React from 'react';
import * as R from 'ramda';
import {mapWithIndex, toDollar} from '@/util';
import {useTranslation} from 'react-i18next';

const itemList = (plan, tr) => {
  const baseItems = R.map(R.zipObj(['field', 'value']))([
    [tr('life_cash_value'), plan.cashValue],
    [tr('life_dividend'), plan.accumulatedDividend],
    [tr('life_future_deposit'), plan.futureDeposit],
    [tr('life_loan_balance'), plan.loanBalance],
    [tr('life_next_levy'), plan.nextLevy],
    [
      tr('life_estimated_premium_and_levy_amount'),
      plan.estimatedPremiumAndLevyAmount,
    ],
  ]);

  const aiaItems = R.map(R.zipObj(['field', 'value']))([
    [tr('life_cash_value'), plan.cashValue],
    [tr('life_dividend'), plan.accumulatedDividend],
    [tr('life_future_deposit'), plan.futureDeposit],
    [tr('life_loan_balance'), plan.loanBalance],
    [
      tr('life_accumulated_guaranteed_coupon'),
      plan.accumulatedGuaranteedCoupon,
    ],
    [tr('life_terminal_dividend'), plan.terminalDividend],
    [tr('life_surrender_value'), plan.surrenderValue],
    [tr('life_next_due_premium'), plan.nextDuePremium],
    [tr('life_vitality_discount'), plan.vitalityDiscount],
    [tr('life_premium_refund'), plan.premiumRefund],
    [tr('life_next_levy'), plan.nextLevy],
    [
      tr('life_estimated_premium_and_levy_amount'),
      plan.estimatedPremiumAndLevyAmount,
    ],
  ]);

  const items = R.compose(
    result =>
      R.ifElse(
        R.has('totalPolicyValue'),
        R.always(
          R.concat(result, [
            {
              field: tr('life_total_policy_value'),
              value: plan.totalPolicyValue,
            },
          ])
        ),
        R.always(result)
      )(plan),
    R.cond([[R.equals('AIA'), R.always(aiaItems)], [R.T, () => baseItems]])
  );

  const genList = mapWithIndex((item, idx) => (
    <tr key={idx}>
      <td>{item.field}</td>
      <td className='text-right'>{toDollar(item.value)}</td>
    </tr>
  ));
  return genList(items(plan.providerShortName));
};

const PolicyValue = ({plan}) => {
  const {t: tr} = useTranslation('statements');
  if (plan.disabledPolicyValueSection) return null;

  return (
    <section className='plan-details'>
      <h4>{tr('life_policy_value')}</h4>
      <table className='table table-striped table-borderless'>
        <thead>
          <tr>
            <th>{tr('pd_description')}</th>
            <th className='text-right'>
              {tr('life_amount')}({`${plan.currency}`})
            </th>
          </tr>
        </thead>
        <tbody>{itemList(plan, tr)}</tbody>
      </table>
    </section>
  );
};

export default PolicyValue;
